import { render, staticRenderFns } from "./ProjectStatusSelect.vue?vue&type=template&id=1c40adca&scoped=true&"
import script from "./ProjectStatusSelect.vue?vue&type=script&lang=js&"
export * from "./ProjectStatusSelect.vue?vue&type=script&lang=js&"
import style0 from "./ProjectStatusSelect.vue?vue&type=style&index=0&id=1c40adca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c40adca",
  null
  
)

export default component.exports